import type { LotStoryProjectionTimelineEvent } from '../../types/lotStory'

export type StoryTimelineAuditEntry = {
  eventId: string
  eventType: LotStoryProjectionTimelineEvent['eventType']
  recordedAt: string
  notes: string
}

export type StoryTimelineAuditSummary = {
  totalEvents: number
  notedEventsCount: number
  latestEventAt?: string
  latestNotedEventAt?: string
  recentNotedEntries: StoryTimelineAuditEntry[]
}

const normalizeNotes = (value: string | undefined): string => {
  const normalized = value?.trim()
  return normalized ? normalized : ''
}

const toTimestamp = (value: string): number => {
  const parsed = new Date(value).getTime()
  return Number.isFinite(parsed) ? parsed : Number.NEGATIVE_INFINITY
}

export const buildStoryTimelineAuditSummary = (args: {
  events: LotStoryProjectionTimelineEvent[]
  notedEntriesLimit?: number
}): StoryTimelineAuditSummary => {
  const notedEntriesLimit = args.notedEntriesLimit ?? 3
  const sortedByRecordedAtDesc = [...args.events].sort((left, right) => (
    toTimestamp(right.recordedAt) - toTimestamp(left.recordedAt)
  ))

  const notedEvents = sortedByRecordedAtDesc
    .map((event) => ({
      eventId: event.eventId,
      eventType: event.eventType,
      recordedAt: event.recordedAt,
      notes: normalizeNotes(event.notes)
    }))
    .filter((event) => event.notes.length > 0)

  return {
    totalEvents: args.events.length,
    notedEventsCount: notedEvents.length,
    latestEventAt: sortedByRecordedAtDesc[0]?.recordedAt,
    latestNotedEventAt: notedEvents[0]?.recordedAt,
    recentNotedEntries: notedEvents.slice(0, Math.max(0, notedEntriesLimit))
  }
}